import React from "react";
import { ConvertEnglish } from "../../../../../components/ConterEnglsih";

const CollectorTable = ({collector,totalCollectorPayments,totalTodayPayments}) => {
  return (
    <table className="table w-full ">
      {/* <!-- head --> */}
      <thead>
        <tr>
          <td>
            <span>{collector?.name}</span>
          </td>
          <td>
            <ConvertEnglish english={"Bill"} bangla={"বিল"} />
          </td>
        </tr>
      </thead>
      <tbody>
        {/* <!-- row 1 --> start*/}
        <tr>
          <td>
            <ConvertEnglish english={"Today"} bangla={"আজকার বিল"} />
          </td>
          <td>
            <span className="text-2xl font-bold">{totalTodayPayments}</span> <span className="text-2xl font-bold">৳</span>
          </td>
        </tr>
        <tr>
          <td>
            <ConvertEnglish english={"Total"} bangla={"মোট"} />
          </td>
          <td>
           <span className="text-2xl font-bold">{totalCollectorPayments}</span> <span className="text-2xl font-bold">৳</span>
          </td>
        </tr>
        {/* <!-- row 1 --> end*/}
      </tbody>
    </table>
  );
};

export default CollectorTable;
